<template>
  <li class="level-menu outside" @click="openlevelmenu" v-if="checkRole(['agent', 'admin'], ['ccp'])">
    <a class="nav-link" href="#">
      <feather type="airplay"></feather>
      <span>CCP</span>
    </a>
    <ul style="z-index: 20;text-align: left; width: auto;" class="header-level-menu menu-to-be-close"
      :class="{ 'd-block': openLevelmenu }">
      <li @click="$router.push('/ccp/desktop')" v-if="checkRole(['agent', 'admin'], ['ccp'])" class='clickMenu'>
        <span>Agent Desktop</span>
      </li>
      <li @click="$router.push('/ccp/folder')" v-if="checkRole(['admin'], ['ccp'])" class='clickMenu'>
        <span>Email Template Folder</span>
      </li>
      <li @click="$router.push('/ccp/template')" v-if="checkRole(['admin'], ['ccp'])" class='clickMenu'>
        <span>Email Template</span>
      </li>
      <li @click="$router.push('/ccp/queue')" v-if="checkRole(['admin', 'agent'], ['ccp'])" class='clickMenu'>
        <span>Email Queue</span>
      </li>
      <li @click="$router.push('/ccp/priority')" v-if="checkRole(['admin'], ['ccp'])" class='clickMenu'>
        <span>Email Priority</span>
      </li>



      <li v-if="checkRole(['admin'], ['ccp'])" style=" border-top: 1px solid #ccc;">
        <span>Report</span>
      </li>
      <li @click="$router.push('/ccp/detail')" v-if="checkRole(['admin'], ['ccp'])" class='clickMenu'>
        <feather type="corner-down-right"></feather>
        <span>Report Detail</span>
      </li>
      <li @click="$router.push('/ccp/daily')" v-if="checkRole(['admin'], ['ccp'])" class='clickMenu'>
        <feather type="corner-down-right"></feather>
        <span>Report Daily</span>
      </li>
      <li @click="$router.push('/ccp/monthly')" v-if="checkRole(['admin'], ['ccp'])" class='clickMenu'>
        <feather type="corner-down-right"></feather>
        <span>Report Monthly</span>
      </li>
    </ul>
  </li>
</template>

<script>
export default {
  name: 'LevelMenu',
  data() {
    return {
      openLevelmenu: false,
    };
  },
  methods: {
    openlevelmenu() {
      this.openLevelmenu = !this.openLevelmenu;
      if (this.openLevelmenu) {
        this.$emit('closeMenu')
      }
    },
    checkRole(role, module) {

      if (role == undefined && module == undefined) {
        return false
      }
      let status_ccp = false
      let status_beacon = false
      let userinfo = localStorage.getItem("userinfo")
      userinfo = JSON.parse(userinfo)
      for (let i = 0; i < module.length; i++) {
        if (module[i] == "beacon") {
          if (userinfo.role_beacon == undefined) {
            status_beacon = false
          }
          status_beacon = role.includes(userinfo.role_beacon);
        }
        else if (module[i] == "ccp") {
          if (userinfo.role_ccp == undefined) {
            status_ccp = false
          }
          status_ccp = role.includes(userinfo.role_ccp);
        }
      }
      return (status_ccp || status_beacon)
    },
  },
};
</script>

<style scoped>
.clickMenu {
  cursor: pointer;
}

.clickMenu:hover {
  color: #2A71FB;
}
</style>
